/**
 * Stitch module page shell — use across ZTask/ZOrder/ZAsset/etc.
 * Wraps content with design-system chrome. Never injects mock data.
 */
import React from "react";
import { PageHeader } from "./States";
import "./crane-tokens.css";

export function ModulePage({
  crumbs = [],
  title,
  description = null,
  actions = null,
  children,
  className = "",
}) {
  return (
    <div className={`crane-page ${className}`.trim()}>
      <PageHeader crumbs={crumbs} title={title} description={description} actions={actions} />
      {children}
    </div>
  );
}

export function ModuleToolbar({ children }) {
  return <div className="crane-filters" style={{ marginBottom: 16 }}>{children}</div>;
}

export function ModuleCard({ title, badge = null, children, headerActions = null }) {
  return (
    <div className="crane-card">
      {(title || headerActions || badge) && (
        <div className="crane-card__header">
          <h3 className="crane-card__title">{title}</h3>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {badge}
            {headerActions}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}

export function StatusBadge({ children, tone = "ok" }) {
  const cls =
    tone === "err" ? "crane-badge crane-badge--err" : tone === "warn" ? "crane-badge crane-badge--warn" : "crane-badge crane-badge--ok";
  return <span className={cls}>{children}</span>;
}

export default ModulePage;
